<script setup lang="ts">
import AppShell from './features/shell/AppShell.vue';
import AuthLayout from './features/auth/AuthLayout.vue';
</script>

<template>
  <RouterView v-slot="{ Component, route }">
    <AuthLayout v-if="route.meta.layout === 'auth'">
      <component :is="Component" />
    </AuthLayout>
    <AppShell v-else-if="Component">
      <component :is="Component" />
    </AppShell>
  </RouterView>
</template>
